import React, { useEffect, useReducer } from "react";
import {
  hospitalStatus as hospitalStatusReducer,
  initialStatus as initialHospitalStatus,
  nedocsReducer,
  initialNedocs,
} from "../reducers";
import { hospitalActions } from "../actions";
import { Footer } from "../components/Footer";
import { BodyHomePage } from "../components/BodyHomePage";
import { useNavigation } from "../components/NavigationProvider";
import { PromotionalBanner } from "../components/PromotionalBanner";
import { useInternationalization } from "../hooks/useInternationalization";
import { Header } from "../components/Header";
import { BannerStoreMobile } from "../components/BannerStoreMobile"
import { Loader } from "../components/Loader";
import { useIntl } from "react-intl";
import { PoliclinicoMapComponent } from "../components/PoliclinicoMapComponent";
import { deviceStoreLinks } from '../utils/deviceStoreLinks';
import { getDeviceType } from '../utils/detectDevice';
import useWindowSize from "../hooks/useWindowSize";

export const HomePage = ({ history }) => {
  const [hospitalStatus, updateHospitalStatus] = useReducer(
    hospitalStatusReducer,
    initialHospitalStatus
  );
  const [nedocsStatus, updateNedocs] = useReducer(nedocsReducer, initialNedocs);

  const [navigation, dispatchNavigation] = useNavigation();
  const { locale } = useInternationalization();
  const intl = useIntl();

  // Conditional rendering for extra small devices (phones, 600px and down) and others
  const windowSize = useWindowSize();
  const isExtraSmallDevice = windowSize === 'xs' || windowSize === 'sm';

  useEffect(() => {
    hospitalActions.hospitalNedocs("20700", updateNedocs, intl);
    hospitalActions.statusProntoSoccorso("20700", locale, updateHospitalStatus, intl);
  }, [locale, intl]);

  return (
    <React.Fragment>
      {
        isExtraSmallDevice ?
          <BannerStoreMobile
            storeLink={deviceStoreLinks[getDeviceType()]} /> :
          null
      }
      <Header history={history} />
      {
        (() => {
          if (hospitalStatus.pristine || nedocsStatus.pristine || hospitalStatus.error || nedocsStatus.error) {
            return null;
          }

          if (hospitalStatus.loading || nedocsStatus.loading) {
            return <Loader />;
          }

          return (
            <BodyHomePage
              hospitalStatus={hospitalStatus}
              nedocsValue={nedocsStatus.nedocs.value}
              history={history}
              dispatch={dispatchNavigation}
              language={navigation.language}
            />
          );
        })()
      }
      <PoliclinicoMapComponent marginTop="2rem" />
      <PromotionalBanner storeLinks={deviceStoreLinks} />
      <Footer />
    </React.Fragment>
  );
};
